// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3NQzb","header":"ReportDetails_header__1wXOB","title":"ReportDetails_title__1S3hO","left":"ReportDetails_left__3eNIQ"};